// export const LOGIN_URL = 'https://assetapi.verismartsoft.biz/api/gettoken';
export const LOGIN_URL = process.env.REACT_APP_BASE_URL + '/api/gettoken';

export const LOGIN_URL_PROXY = './api/gettoken';

export const ALERT_UPDATE_SUCCESS = 'alerts.updateSuccess';
export const ALERT_INSERT_SUCCESS = 'alerts.addSuccess';
export const ALERT_INVALID_INPUT = 'alerts.invalidInput';
